import Vue from 'vue'
import Router from 'vue-router'
import PcSearchPage from '@/components/searchPage'
import PcIndex from '@/components/homePage'
import IosSearchPage from '@/ios/searchPage'
import IosIndex from '@/ios/homePage'
import MobileSearchPage from '@/mobile/searchPage'
import MobileIndex from '@/mobile/homePage'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '',
      redirect: '/pc_index'
    },
    {
      path: "/pc_index", // pc端首页
      name: PcIndex,
      component: PcIndex
    },
    {
      path: '/ios_index', // ios端首页
      name: IosIndex,
      component: IosIndex
    },
    {
      path: '/m_index', // 其它手机端首页
      name: MobileIndex,
      component: MobileIndex
    },
    {
      path: '/pcList',
      component: PcSearchPage,
      name: 'pcList',
      meta: { title: '以图搜图', icon: 'el-icon-document-copy' }
    },
    {
      path: '/iosList',
      component: IosSearchPage,
      name: 'iosList',
      meta: { title: '以图搜图', icon: 'el-icon-document-copy' }
    },
    {
      path: '/mobileList',
      component: MobileSearchPage,
      name: 'mobileList',
      meta: { title: '以图搜图', icon: 'el-icon-document-copy' }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js